/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 16:27:02
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-08-08 14:19:26
 */
export default {
  allRole: '/security/identify/role/query/page',
  addRole: '/security/identify/role/create',
  editRole: '/security/identify/role/edit',
  batchDelRole: '/security/identify/role/delete/batch',
  roleMenu: '/security/identify/menu/query/tree', //角色授权tree
  roleJurisdiction: '/security/identify/role/permission/query',
  sureJurisdiction: '/security/identify/role/permission/create',
  adminList: '/yangtse/identify/admin/user/list',
  adminDelete: '/yangtse/identify/admin/user/batch/delete',
  adminAdd: '/course/manage/admin/batch/add/from/student',
  userMarkList: '/yangtse/user/marking/list',
  userMarkAdd: '/yangtse/user/marking/add',
  userMarkDelete: '/yangtse/user/marking/delete',
  userRoleList: '/yangtse/exam/user/role/list',
  roleList: '/security/identify/role/query/list',
  proctorList: '/yangtse/identify/invigilation/teacher/list',
  proctorAdd: '/yangtse/identify/invigilation/teacher/add',
  proctorDelete: '/yangtse/identify/invigilation/teacher/batch/delete',
  jonWorkTypeList: '/yangtse/filter/job/work/type',
  jonWorkTypeBind: '/yangtse/job/work/type/bind',
  markPlanList: '/yangtse/user/marking/plan/list',
  markBind: '/yangtse/user/marking/bind',
  adminNewAdd: '/yangtse/identify/admin/user/add',
  userAdmin: '/security/identify/user/role/create/batch',
  filterPlan: '/yangtse/filter/plan',
  filterPlanSubject: '/yangtse/filter/plan/subject',
  proctorPlan: '/yangtse/identify/invigilation/teacher/plan/relation/list',
  proctorRemove: '/yangtse/user/marking/remove',
  haha: '/yangtse/haha',
  paperAnsAdd: '/yangtse/paper/ans/add',
  paperAnsList: '/yangtse/paper/ans/list/question',
  xixi: '/yangtse/xixi',
}
